<template>
  <div>
    <div id="home">
      <div style="border-radius: 16px;background-color: #FFDE33;width: 20vw;height: 20vw;display: flex;justify-content: center;align-items: center;">
        <img src="../assets/imgs/kakao.png"/>
      </div>
      <h1>카카오톡 로그인 중</h1>
      <p>잠시만 기다려 주세요</p>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import { getAction } from '@/network/manage';
  import moment from 'moment/moment';
  export default {
    name: 'KakaoLogin',
    components: {

    },
    data() {
      return {
      }
    },
    mounted() {
      this.initDate()
    },
    methods:{
      async initDate(){
        let code;
        let state;
        if (this.$route.query && this.$route.query.code && this.$route.query.code !== '') {
          code = this.$route.query.code
        }
        if (this.$route.query && this.$route.query.state && this.$route.query.state !== '') {
          state = this.$route.query.state
        }
        const res = await getAction('/app/auth/kakaoAuthLogin/' + code)
        if(res.code == 200 || res.code == 0) {
            Vue.ls.set("kakaoPhone", res.result.phoneNumber)
            Vue.ls.set("email", res.result.email)
            Vue.ls.set("nickname", res.result.nickname)
            Vue.ls.set("name", res.result.name)
        }
        if(state == 2) {
          this.$router.replace('/validatePhone')
        } else {
          this.$router.replace('/phoneValidate')
        }
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;align-items: center;justify-content: center;}
  h1{color:#333333;font-size: 24px;text-align: center;margin:20px 0 10px 0;}
  p{color: #717B85;text-align: center;}
  .btn{display: flex;justify-content: center;background:#FFDE33;margin-top:30px;align-items: center;padding:0 20px;height: 52px;border-radius: 26px;font-weight: bold;}
  .btn img{width: 16px;margin-right: 6px;}
</style>
